import { IGetMiddlewareSDK } from '@orbis-systems/omni-sdk-ts/dist/types/apis/middleware';
import { OrbisSdkWrapper } from '../OrbisSdkWrapper';

export * from './Account.type';
export * from './Branch.type';
export * from './CorporateAction.type';
export * from './Document.type';
export * from './DriftReport.type';
export * from './Group.type';
export * from './Market.type';
export * from './Model.type';
export * from './News.type';
export * from './Order.type';
export * from './Portfolio.type';
export * from './Quote.type';
export * from './Research.type';
export * from './Stat.type';
export * from './Tipranks.type';
export * from './Trading.type';
export * from './User.type';
export * from './Watchlist.type';

export enum CacheLevel {
    NoCache,
    RequestsOnly,
    RequestsAndCalculations,
}

export interface ApiPermissions {
    advisor: boolean;
    rtbs: boolean;
    iav: boolean;
    documents: boolean;
    transfers: boolean;
    iavProcessorToken: boolean;
}

export interface MiddlewareConfig {
    appEnv?: string;
    websocketUrl?: string;
    cacheDuration: number;
    cacheLevel: CacheLevel;
    apiPermissions: ApiPermissions;
}

export interface Sdks {
    orbis: OrbisSdkWrapper;
    middleware: IGetMiddlewareSDK;
}

export type BranchInfo = {
    balance: number;
    cash: number;
    portfolioValue: number;
    monthlyCashflow: number;
    totalModels: number;
    totalAccounts: number;
    totalGroups: number;
};

export type HoldingInfo = {
    totalValue: number;
    totalCostValue: number;
    gainPercent: number;
    price: number;
    totalHolding: number;
    positionWeight: number;
    modelTarget: number;
};

export type Rtbs = {
    balance: number;
    totalDividendAmount: number;
    totalDividendYield: number;
    sodCashBalance: number;
    sodMarginBalance: number;
    sodShortBalance: number;
    cashOnAccount: number;
    markToMarket: number;
};
